import { User } from '../models/user';

export class FetchUserInfoSuccess {
    static readonly type = '[User] FetchUserInfoSuccess';

    constructor(public payload: User) {}
}
